import React from 'react';
import { IpaType } from '../../phonemes/ipa';
import { ipaToSynthSymbols } from '../../speak/exact';
import { ipaToSynth } from '../../speak/ipaToSynth';
import { speakSegment } from '../speakSegment';
import { FormantsChart } from './FormantsChart';

/** show vowel on a formants chart w/ their synth approximations that you can hear */
export function SynthVowelFormants() {
  function lookup(ipa: IpaType): string {
    // use exact if present (useful for stuff like /u/),
    // otherwise run rules (useful for stuff that's approximated)
    const speak = ipaToSynthSymbols[ipa] ?? ipaToSynth(ipa).speak;
    return ipa + ':' + speak;
  }

  function clicked(ipa: IpaType) {
    speakSegment(ipa);
  }

  return <FormantsChart width={600} height={300} clicked={clicked} lookup={lookup} />;
}